//-------------------------------
//
//  汎用バリデーション「入力必須」
//
//-------------------------------
function validationRequired(value) {
    if (value === "") {
        return "入力必須です。";
    } else {
        return null;
    }
}
//-------------------------------
//
//  汎用バリデーション「禁止記号チェック」
//
//-------------------------------
function validationNgSign(value) {
    const forbiddenPattern = /[<>"'`]/;
    if (forbiddenPattern.test(value)) {
        return "使用できない文字（<>\"\'等）が含まれています。";
    } else {
        return null;
    }
}
//-------------------------------
//
//  汎用バリデーション「最大文字数」
//
//-------------------------------
function validationMaxLength(value, maxNum) {
    const max = Number(maxNum);
    if (value.length > max) {
        return `${max}文字以内で入力してください。`;
    } else {
        return null;
    }
}
//-------------------------------
//
//  汎用バリデーション「整合チェック」
//  ※入力されたふたつの値が一致しているか
//
//-------------------------------
function validationDuplicate(valueA, valueB) {
    if (valueA !== valueB) {
        return "入力された内容が一致していません。";
    } else {
        return null;
    }
}
//-------------------------------
//
//  汎用バリデーション「メールアドレス」
//
//-------------------------------
function validationEmailPattern(value) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(value)) {
        return "正しいメールアドレスの形式で入力してください。";
    } else {
        return null;
    }
}
//-------------------------------
//
//  汎用バリデーション「電話番号」
//
//-------------------------------
function validationTelPattern(value) {
    const normalizedValue = value.replace(/[━ー－―‐-]/g, "").replace(/\s/g, "");
    const telPattern = /^0\d{9,10}$/;
    if (!telPattern.test(normalizedValue)) {
        return "正しい電話番号の形式で入力してください。";
    } else {
        return null;
    }
}
//-------------------------------
//
//  汎用バリデーション「郵便番号」
//
//-------------------------------
function validationPostcodePattern(value) {
    const normalizedValue = value.replace(/[━ー－―‐-]/g, "").replace(/\s/g, "");
    const postcodePattern = /^\d{7}$/;
    if (!postcodePattern.test(normalizedValue)) {
        return "正しい郵便番号の形式で入力してください。";
    } else {
        return null;
    }
}
//-------------------------------
//
//  汎用バリデーション「セレクト未選択」
//
//-------------------------------
function validationNonSelect(value) {
    if (value === "--") {
        return "未選択の項目があります。";
    } else {
        return null;
    }
}
//-------------------------------
//
//  送信判定用変数
//
//-------------------------------
let judge = [];
//-------------------------------
//
//  input取得
//
//-------------------------------
//  form
const form = document.getElementById("form");
// uuid
const uuid = document.getElementById("uuid");
//  お名前
const input_name = document.getElementById("input-name");

//  所属（フォーム全体で共通のその他項目を取得）
const input_category = document.getElementById("radio-category-9");
//  所属（追記テキスト欄）
const category_details = document
    .getElementById("row-category")
    .querySelectorAll(".c-input-radio__details-input");

//  生年月日
const input_birthday = document.getElementById("input-birthday");
const birth_year = document.getElementById("birth-year");
const birth_month = document.getElementById("birth-month");
const birth_day = document.getElementById("birth-day");

//  メールアドレス
const input_email = document.getElementById("email");
const input_email_confirm = document.getElementById("email-confirm");
if (input_email && input_email_confirm) {
    //  コピペ禁止制御
    ["copy", "cut"].forEach((type) => {
        input_email.addEventListener(type, (event) => {
            event.preventDefault();
        });
    });
    input_email_confirm.addEventListener("paste", (event) => {
        event.preventDefault();
    });
}

//  電話番号
const input_tel = document.getElementById("tel");

//  住所
const input_address = document.getElementById("input-address");
//  住所（郵便番号）
const input_postcode = document.getElementById("postcode");
//  住所（都道府県）
const input_prefecture = document.getElementById("prefecture");
//  住所（詳細）
const input_address_main = document.getElementById("address_main");
const input_address_sub = document.getElementById("address_sub");

//  きっかけ
const input_trigger = document.getElementById("trigger-1");
const row_trigger = document.getElementById("row-trigger");
const trigger_details = row_trigger
    ? row_trigger.querySelectorAll(".c-input-radio__details-input")
    : [];

//  お問い合わせ内容
const input_message = document.getElementById("message");

//  エラートップメッセージ
const error_top = document.querySelector(".p-form__error-top");
const error_top_message = "入力内容に不備があります。お手数ですが内容を確認し修正してください。";

//-------------------------------
//
//  共通検証
//  引数にエラー文を入れるための配列変数と
//  検証結果を返すvalidation関数を渡す
//
//-------------------------------
function addError(errors, result) {
    if (result) {
        errors.push(result);
    }
}
//-------------------------------
//
//  共通エラーリセット
//  検証前に一度エラー文をリセットする
//
//-------------------------------
const errorSetTags = document.querySelectorAll(".p-form__data-error");
function ErrorReset() {
    if (errorSetTags.length > 0) {
        errorSetTags.forEach((tag) => {
            tag.innerHTML = "";
        });
    }
}

//-------------------------------
//
//  共通エラーセット
//  エラー文を各項目の専用タグに出力
//
//-------------------------------
function SetErrorMessage(target, errors) {
    if (errors.length > 0) {
        const message = errors.join("／");
        const errorTag = target.closest(".p-form__data").querySelector(".p-form__data-error");
        errorTag.innerHTML = `<span>${message}</span>`;
    }
}

//-------------------------------
//
//  共通判定結果セット
//  検証全体での合否（送信可否）を判定するための各項目での処理
//
//-------------------------------
function setJudgeData(errors, name) {
    if (errors.length > 0) {
        judge.push(name);
    }
}
//-------------------------------
//
//  検証「お名前」
//
//-------------------------------
function checkName() {
    let errors = [];
    if (input_name) {
        const value = input_name.value;
        addError(errors, validationRequired(value));
        addError(errors, validationNgSign(value));
        addError(errors, validationMaxLength(value, 80));
        SetErrorMessage(input_name, errors);
        setJudgeData(errors, "name");
    }
}
//-------------------------------
//
//  検証「所属（追記テキスト欄のみ）」
//
//-------------------------------
function checkCategoryDetails() {
    let errors = [];
    if (input_category && category_details.length > 0) {
        category_details.forEach((detail) => {
            addError(errors, validationNgSign(detail.value));
            SetErrorMessage(input_category, errors);
            setJudgeData(errors, "category");
        });
    }
}
//-------------------------------
//
//  検証「生年月日」
//
//-------------------------------
function checkBirthday() {
    let errors = [];
    if (input_birthday) {
        addError(errors, validationNonSelect(birth_year.value));
        addError(errors, validationNonSelect(birth_month.value));
        addError(errors, validationNonSelect(birth_day.value));
        //  配列内のエラー文重複を削除
        errors = [...new Set(errors)];
        SetErrorMessage(input_birthday, errors);
        setJudgeData(errors, "birthday");
    }
}
//-------------------------------
//
//  検証「メールアドレス」
//
//-------------------------------
function checkEmail() {
    let errors = [];
    if (input_email && input_email_confirm) {
        const value = input_email.value;
        const value_cnf = input_email_confirm.value;
        addError(errors, validationRequired(value));
        addError(errors, validationNgSign(value));
        addError(errors, validationEmailPattern(value));
        addError(errors, validationDuplicate(value, value_cnf));
        SetErrorMessage(input_email, errors);
        setJudgeData(errors, "email");
    }
}
//-------------------------------
//
//  検証「電話番号」
//
//-------------------------------
function checkTel() {
    let errors = [];
    if (input_tel) {
        const value = input_tel.value;
        addError(errors, validationRequired(value));
        addError(errors, validationNgSign(value));
        addError(errors, validationTelPattern(value));
        SetErrorMessage(input_tel, errors);
        setJudgeData(errors, "tel");
    }
}
//-------------------------------
//
//  検証「住所」
//
//-------------------------------
function checkAddress() {
    let errors = [];
    if (input_address) {
        const value_post = input_postcode.value;
        const value_pre = input_prefecture.value;
        const value_ad1 = input_address_main.value;
        const value_ad2 = input_address_sub.value;

        //  郵便番号
        addError(errors, validationRequired(value_post));
        addError(errors, validationNgSign(value_post));
        addError(errors, validationPostcodePattern(value_post));
        //  都道府県
        addError(errors, validationNonSelect(value_pre));
        //  住所-メイン
        addError(errors, validationRequired(value_ad1));
        addError(errors, validationNgSign(value_ad1));
        addError(errors, validationMaxLength(value_ad1, 100));
        //  住所-サブ
        addError(errors, validationNgSign(value_ad2));
        addError(errors, validationMaxLength(value_ad2, 100));
        //  配列内のエラー文重複を削除
        errors = [...new Set(errors)];
        SetErrorMessage(input_address, errors);
        setJudgeData(errors, "address");
    }
}
//-------------------------------
//
//  検証「きっかけ（追記テキスト欄のみ）」
//
//-------------------------------
function checkTriggerDetails() {
    let errors = [];
    if (input_trigger && trigger_details.length > 0) {
        trigger_details.forEach((detail) => {
            addError(errors, validationNgSign(detail.value));
            SetErrorMessage(input_trigger, errors);
            setJudgeData(errors, "trigger");
        });
    }
}
//-------------------------------
//
//  検証「メッセージ」
//
//-------------------------------
function checkMessage() {
    let errors = [];
    if (input_message) {
        const value = input_message.value;
        addError(errors, validationRequired(value));
        addError(errors, validationNgSign(value));
        addError(errors, validationMaxLength(value, 1000));
        SetErrorMessage(input_message, errors);
        setJudgeData(errors, "message");
    }
}

//-------------------------------
//
//  送信ボタン
//
//-------------------------------
const submit_button = document.getElementById("submit-button");
if (submit_button) {
    form.addEventListener("submit", (event) => {
        //  送信中断
        event.preventDefault();

        //最初に実行
        judge = [];
        ErrorReset();

        //各種検証
        checkName();
        checkCategoryDetails();
        checkBirthday();
        checkEmail();
        checkTel();
        checkAddress();
        checkTriggerDetails();
        checkMessage();

        if (judge.length === 0) {
            error_top.innerHTML = "";
            form.submit();
        } else {
            //  エラーメッセージ挿入
            if (error_top) {
                error_top.innerHTML = `<span>${error_top_message}</span>`;
            }
            //  ページ上部へ
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }
    });
}
